<template>
  <figure class="collection-grid" v-if="image">
    <el-image :src="image" fill="cover" />
  </figure>
  <!-- <figure class="collection-grid" :class="['count-' + images.length]" v-else-if="images.length !== 0">
    <i v-for="(thumbnail, index) in images" :key="index">
      <img v-if="thumbnail" :src="thumbnail"  />
    </i>
  </figure> -->
  <figure class="collection-grid" :class="['count-4']" v-else-if="images.length !== 0">
    <i v-for="(thumbnail, index) in displayImages" :key="index">
      <img v-if="thumbnail" :src="thumbnail"  />
    </i>
  </figure>
  <figure class="collection-grid count-4" v-else>
    <i></i>
    <i></i>
    <i></i>
    <i></i>
  </figure>
</template>
  
<script setup>
  import { computed } from 'vue';
  import { ElImage } from 'element-plus';

  const props = defineProps({
    image: {
      type: String,
      default: ''
    },
    images: [
      {
        type: Array,
        default: []
      }
    ]
  });

  const displayImages = computed(() => {
    const result = [...props.images];
    while (result.length < 4) {
      result.push('');
    }
    return result.slice(0, 4);
  });
  </script>
  
<style lang="scss">

  .collection-grid {
    overflow: hidden;
    border-radius: var(--radius);
    background-color: var(--Black-05);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    .el-image {
      height: 100%;
      display: block;

      .el-image__inner {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &.count-1 {
      i {
        width: 100%;
        height: 100%;
        display: block;
      }
    }

    &.count-2 {
      i {
        width: 50%;
        height: 100%;
        display: block;
        position: absolute;
        box-sizing: border-box;

        &:nth-child(1) {
          top: 0;
          left: 0;
          border-right: 1px solid var(--Bg-light);
        }

        &:nth-child(2) {
          top: 0;
          right: 0;
        }
      }
    }

    &.count-3 {
      i {
        width: 50%;
        height: 50%;
        display: block;
        position: absolute;
        box-sizing: border-box;

        &:nth-child(1) {
          top: 0;
          left: 0;
          width: 100%;
          border-bottom: 1px solid var(--Bg-light);
        }

        &:nth-child(2) {
          bottom: 0;
          left: 0;
          border-right: 1px solid var(--Bg-light);
        }

        &:nth-child(3) {
          bottom: 0;
          right: 0;
        }
      }
    }

    &.count-4 {
      i {
        width: 50%;
        height: 50%;
        display: block;
        position: absolute;
        box-sizing: border-box;

        &:nth-child(1) {
          top: 0;
          left: 0;
          border-bottom: 1px solid var(--Bg-light);
          border-right: 1px solid var(--Bg-light);
        }

        &:nth-child(2) {
          top: 0;
          right: 0;
          border-bottom: 1px solid var(--Bg-light);
        }

        &:nth-child(3) {
          bottom: 0;
          left: 0;
          border-right: 1px solid var(--Bg-light);
        }

        &:nth-child(4) {
          bottom: 0;
          right: 0;
        }
      }
    }

    .ui-image {
      width: 100%;
      height: 100%;
    }
  }
</style>